import {
  StockCommandEnvelopeV1Schema,
  type StockCommandEnvelopeV1,
  type SharedTabletOperatorAssertion,
} from '@trackeat/shared';
import { beginStockCommandSend, retryStockCommand } from './stockCommandOutbox.js';
import { stockCommandSqliteStorage, type PendingStockCommandBatch } from './stockCommandSqlite.js';

/** A malformed persisted operation must not prevent healthy commands or pull. */
export async function prepareStockCommandPush(
  batches: PendingStockCommandBatch[],
  resolveOperator: (batch: PendingStockCommandBatch) => Promise<{
    deviceId: string; assertion?: SharedTabletOperatorAssertion;
  }>,
): Promise<Array<{ batch: PendingStockCommandBatch; envelope: StockCommandEnvelopeV1 }>> {
  const ready: Array<{ batch: PendingStockCommandBatch; envelope: StockCommandEnvelopeV1 }> = [];
  for (const batch of batches) {
    await beginStockCommandSend(stockCommandSqliteStorage, batch.handle);
    try {
      const operator = await resolveOperator(batch);
      const envelope = StockCommandEnvelopeV1Schema.parse({
        schema: 'trackeat.stock-command', version: 1,
        command: batch.record.command, command_digest: batch.record.digest,
        device_id: operator.deviceId, operator_assertion: operator.assertion,
        events: batch.events, master_effects: [...batch.record.master_effects],
      });
      ready.push({ batch, envelope });
    } catch (error) {
      // Preserve the original envelope, digest and optimistic facts. The timed
      // retry can recover after an app update; no permanent rejection/reprint.
      await retryStockCommand(stockCommandSqliteStorage, batch.handle,
        `client_prepare_failed:${error instanceof Error ? error.message : String(error)}`);
    }
  }
  return ready;
}
